import * as THREE from 'three';

export class FikoHatchingShader extends THREE.ShaderMaterial {
  constructor() {
    super({
      uniforms: {
        uColor: { value: new THREE.Color(0xaaaaaa) }, // Base color for the model
        uLightDir: { value: new THREE.Vector3(0.0, 0.0, 1.0) }, // Default light direction
        uHatchSpacing: { value: 0.015 }, // Spacing between hatch lines
        uHatchAngle: { value: 0.785 }, // Angle of hatch lines (45 degrees in radians)
      },
      vertexShader: `
        varying vec3 vNormal;
        varying vec3 vWorldPosition;
        void main() {
          vNormal = normalize(normalMatrix * normal);
          vWorldPosition = (modelMatrix * vec4(position, 1.0)).xyz;
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
      `,
      fragmentShader: `
        precision highp float;
        uniform vec3 uColor;
        uniform vec3 uLightDir;
        uniform float uHatchSpacing;
        uniform float uHatchAngle;
        varying vec3 vNormal;
        varying vec3 vWorldPosition;

        void main() {
          vec3 normal = normalize(vNormal);
          vec3 lightDir = normalize(uLightDir);
          float diffuse = max(dot(normal, lightDir), 0.0);

          vec2 rotatedPos;
          float c = cos(uHatchAngle);
          float s = sin(uHatchAngle);

          // Rotate world position for hatching effect
          rotatedPos.x = vWorldPosition.x * c - vWorldPosition.y * s;
          rotatedPos.y = vWorldPosition.x * s + vWorldPosition.y * c;

          float hatchPattern1 = mod(rotatedPos.x / uHatchSpacing, 1.0);
          float hatchPattern2 = mod((rotatedPos.x + rotatedPos.y * 0.5) / uHatchSpacing, 1.0); // Secondary pattern for density
          float hatchPattern3 = mod((rotatedPos.y - rotatedPos.x * 0.5) / uHatchSpacing, 1.0); // Third pattern

          float hatchEffect = 0.0;

          // Vary hatching density based on diffuse lighting
          if (diffuse < 0.25) { // Darkest areas, most hatching
              hatchEffect = step(0.5, hatchPattern1) + step(0.5, hatchPattern2) + step(0.5, hatchPattern3);
          } else if (diffuse < 0.5) { // Medium dark areas
              hatchEffect = step(0.5, hatchPattern1) + step(0.5, hatchPattern2);
          } else if (diffuse < 0.75) { // Lighter areas
              hatchEffect = step(0.5, hatchPattern1);
          }
          // Brightest areas have no hatching, or very faint

          hatchEffect = clamp(hatchEffect, 0.0, 1.0); // Clamp to 0 or 1

          vec3 finalColor = mix(uColor, vec3(0.0), hatchEffect * 0.5); // Mix base color with black for hatch lines

          gl_FragColor = vec4(finalColor, 1.0);
        }
      `,
      lights: false,
      side: THREE.DoubleSide,
      dithering: true,
    });
  }
}
